export default "__VITE_ASSET__CZdzV9JJ__"